/* HIQILI blog interactions. No schema generation; no volume/bottle estimates. */
(function () {
  'use strict';
  function calculate(weight, percent, basis) {
    if (!Number.isFinite(weight) || weight <= 0 || !Number.isFinite(percent) || percent < 0 || percent >= 100) {
      throw new Error('Enter a positive weight and a percentage from 0 to less than 100. This mathematical range is not a safe-use recommendation.');
    }
    if (!['base', 'finished', 'finished-base-rate'].includes(basis)) throw new Error('Select a calculation basis.');
    const rate = percent / 100;
    const fragrance = basis === 'finished-base-rate' ? weight * rate / (1 + rate) : weight * rate;
    const base = basis === 'base' ? weight : weight - fragrance;
    return { fragrance, base, total: base + fragrance };
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = { calculate };
  if (typeof document === 'undefined') return;
  const initialized = new WeakSet();
  const reduced = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const scrollBehavior = () => reduced() ? 'auto' : 'smooth';
  function init(root) {
    if (initialized.has(root)) return;
    initialized.add(root);
    const q = selector => root.querySelector(selector);
    const links = Array.from(root.querySelectorAll('.eo-toc-mobile a[href^="#"], .eo-toc-desktop a[href^="#"]'));
    const targetFor = link => {
      let id;
      try { id = decodeURIComponent(link.getAttribute('href').slice(1)); } catch (_) { return null; }
      const target = document.getElementById(id);
      return target && root.contains(target) ? target : null;
    };
    const offset = () => parseFloat(getComputedStyle(root).getPropertyValue('--blog-scroll-offset')) || 120;
    links.forEach(link => link.addEventListener('click', event => {
      const target = targetFor(link);
      if (!target) return;
      event.preventDefault();
      const toc = link.closest('details.eo-toc-mobile');
      if (toc) toc.open = false;
      window.scrollTo({ top: target.getBoundingClientRect().top + window.scrollY - offset(), behavior: scrollBehavior() });
      // Preserve fragment navigation without losing path or query parameters.
      try { window.history.replaceState(null, '', link.getAttribute('href')); } catch (_) { /* sandbox preview */ }
      const original = target.getAttribute('tabindex');
      target.setAttribute('tabindex', '-1'); target.focus({ preventScroll: true });
      target.addEventListener('blur', () => original === null ? target.removeAttribute('tabindex') : target.setAttribute('tabindex', original), { once:true });
    }));
    const top = q('.back-to-top');
    if (top) top.addEventListener('click', () => window.scrollTo({ top:0, behavior:scrollBehavior() }));
    let pending = false;
    const update = () => {
      pending = false;
      let current = null;
      links.forEach(link => { const target = targetFor(link); if (target && target.getBoundingClientRect().top <= offset() + 30) current = target.id; });
      links.forEach(link => {
        const active = targetFor(link)?.id === current;
        link.classList.toggle('active', active);
        if (active) link.setAttribute('aria-current','location'); else link.removeAttribute('aria-current');
      });
      if (top) { top.hidden = window.scrollY < 300; top.classList.toggle('visible', !top.hidden); }
    };
    window.addEventListener('scroll', () => { if (!pending) { pending = true; window.requestAnimationFrame(update); } }, { passive:true });
    window.addEventListener('resize', update); update();
    // Upgrade older blog markup safely, while native details require no JS.
    root.querySelectorAll('.faq-item:not(details), .fo-faq-item:not(details)').forEach(item => {
      const question = item.querySelector('.faq-question, .fo-faq-question');
      const answer = item.querySelector('.faq-answer, .fo-faq-answer');
      if (!question || !answer) return;
      const details = document.createElement('details'); details.className = 'faq-item';
      const summary = document.createElement('summary'); summary.className = 'faq-question'; summary.textContent = question.textContent;
      answer.className = 'faq-answer'; answer.removeAttribute('style');
      details.append(summary, answer); item.replaceWith(details);
    });
    const legacyHeader = q('#tocHeader'), legacyContent = q('#tocContent');
    if (legacyHeader && legacyContent && !legacyHeader.closest('details')) {
      legacyHeader.setAttribute('role','button'); legacyHeader.setAttribute('tabindex','0'); legacyHeader.setAttribute('aria-expanded','false');
      legacyContent.hidden = true;
      const toggle = () => {
        legacyContent.hidden = !legacyContent.hidden;
        legacyContent.style.maxHeight = legacyContent.hidden ? '0' : 'none';
        legacyContent.classList.toggle('open', !legacyContent.hidden);
        legacyHeader.setAttribute('aria-expanded', String(!legacyContent.hidden));
      };
      legacyHeader.addEventListener('click', toggle);
      legacyHeader.addEventListener('keydown', event => { if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); toggle(); } });
    }
    const models = [
      { button:'#fo-calc-btn', weight:'#batch-size', unit:'#batch-unit', rate:'#fragrance-load', fraction:false, output:'#fo-result-main-text', defaultBasis:'finished' },
      { button:'#foCalcBtn', weight:'#waxWeight', unit:'#weightUnit', rate:'#fragranceLoad', fraction:true, output:'#fo-result-val', defaultBasis:'base' }
    ];
    models.forEach(model => {
      const button = q(model.button), weight = q(model.weight), unit = q(model.unit), rate = q(model.rate), output = q(model.output);
      if (!button || !weight || !unit || !rate || !output) return;
      button.setAttribute('type','button');
      const label = document.createElement('label'); label.className = 'fo-basis-label'; label.textContent = 'Input weight / percentage basis';
      const basis = document.createElement('select'); basis.className = 'fo-basis-select';
      [['base','Base/wax weight; percentage of base/wax'], ['finished','Finished batch weight; percentage of finished batch'], ['finished-base-rate','Finished candle weight; percentage of wax']].forEach(([value,text]) => {
        const option = document.createElement('option'); option.value = value; option.textContent = text; basis.append(option);
      });
      basis.value = model.defaultBasis; label.append(basis); button.before(label);
      output.setAttribute('aria-live','polite'); output.setAttribute('role','status');
      const note = q('#fo-tip-text') || q('#fo-load-hint');
      if (note) note.textContent = 'Use the exact supplier/IFRA and base limits. This calculator does not recommend a concentration or convert weight to volume.';
      const grid = q('#fo-result-grid'); if (grid) grid.hidden = true;
      const resultBox = q('#fo-result-box');
      button.addEventListener('click', () => {
        if (grid) { grid.hidden = true; grid.style.display = 'none'; }
        if (resultBox) resultBox.style.display = 'block';
        try {
          const unitValue = unit.value;
          if (!['g','oz','lb'].includes(unitValue)) throw new Error('Choose g, oz or lb by weight—not fluid ounces.');
          const value = Number.parseFloat(rate.value) * (model.fraction ? 100 : 1);
          const result = calculate(Number.parseFloat(weight.value), value, basis.value);
          output.textContent = `Fragrance oil: ${result.fragrance.toFixed(2)} ${unitValue}; base/wax: ${result.base.toFixed(2)} ${unitValue}; finished total: ${result.total.toFixed(2)} ${unitValue} (weight).`;
        } catch (error) { output.textContent = error.message; }
      });
      root.querySelectorAll('.fo-quick-button').forEach(quick => quick.addEventListener('click', () => { rate.value = quick.getAttribute('data-value'); }));
    });
  }
  function scan() { document.querySelectorAll('.blog-container, .fo-page').forEach(root => { if (!root.parentElement?.closest('.blog-container, .fo-page')) init(root); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan, {once:true}); else scan();
  document.addEventListener('shopify:section:load', scan);
})();
